import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteViewZonePlaylistDocument } from './delete.generated';

export const useDeleteViewZonePlaylist = (
  options: ApiOptions<typeof DeleteViewZonePlaylistDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(DeleteViewZonePlaylistDocument, {
    ...useNotifications(DeleteViewZonePlaylistDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.view_zone_playlists.remove_success'),
    }),

    ...options,
  });
};
